export enum PresetType {
  bank = 'Bank',
  customPlainText = 'CustomPlainText',
  customRegex = 'CustomRegex',
  dob = 'Dob',
  email = 'Email',
  ssn = 'Ssn',
  vin = 'Vin'
}

export class Preset {
  type: PresetType;
  displayValue: string;
  patternValue: string;
  titleSuggestion: string;
}

export class Presets {
  bank: Preset = {
    type: PresetType.bank,
    displayValue: 'Bank Account Number (10 or 12 digits)',
    patternValue: String.raw`\b(\d{12}|\d{10})\b`,
    titleSuggestion: 'Preset: Bank Account Number'
  };

  customRegex: Preset = {
    type: PresetType.customRegex,
    displayValue: 'Custom Regular Expression',
    patternValue: '',
    titleSuggestion: 'Custom RegEx (Regular Expression)'
  };

  customPlainText: Preset = {
    type: PresetType.customPlainText,
    displayValue: 'Custom Plain Text',
    patternValue: '',
    titleSuggestion: 'Custom Plain Text'
  };

  dob: Preset = {
    type: PresetType.dob,
    displayValue: 'Date of Birth (mm/dd/yyyy)',
    patternValue: String.raw`\b\d{1,2}\/\d{1,2}\/(?:\d{4}|\d{2})\b`,
    titleSuggestion: 'Preset: DoB (Date of Birth)'
  };

  email: Preset = {
    type: PresetType.email,
    displayValue: 'E-Mail Address (name@domain.com)',
    patternValue: String.raw`\b[A-Za-z0-9\.]*@[A-Za-z0-9\.]*\.\w{2,3}\b`,
    titleSuggestion: 'Preset: E-Mail Address'
  };

  ssn: Preset = {
    type: PresetType.ssn,
    displayValue: 'SSN (###-##-####)',
    patternValue: String.raw`\b\d{3}-\d{2}-\d{4}\b`,
    titleSuggestion: 'Preset: SSN (Social Security Number)'
  };

  vin: Preset = {
    type: PresetType.vin,
    displayValue: 'VIN (17 Digit Alphanumeric)',
    patternValue: String.raw`\b[A-HJ-NPR-Z0-9]{17}\b`,
    titleSuggestion: 'Preset: VIN (Vehicle Identification Number)'
  }

  lookup: Record<PresetType, Preset> = {
    [PresetType.bank]: this.bank,
    [PresetType.customRegex]: this.customRegex,
    [PresetType.customPlainText]: this.customPlainText,
    [PresetType.dob]: this.dob,
    [PresetType.email]: this.email,
    [PresetType.ssn]: this.ssn,
    [PresetType.vin]: this.vin
  }

  all: Preset[] = [this.customRegex, this.customPlainText, this.ssn, this.dob, this.email, this.bank, this.vin];

  byType(type:PresetType) { return this.lookup[type]; }
}